import axios from "axios";
import { BACKEND_ROOT_URL } from "../api";
import { getCookie, clearAllCookies } from "../hooks/useCookies";


const api = axios.create({
  baseURL: BACKEND_ROOT_URL,
  timeout: 60000, // 30 seconds
  headers: {
    "Content-Type": "application/json",
  },
});

// Add an interceptor to automatically include the Authorization token in every request
api.interceptors.request.use(
  (config) => {
    const token = getCookie("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      // console.log("🔑 Adding Authorization header for request:", config.url);
    } else {
      console.log("⚠️ No token found for request:", config.url);
    }
    return config;
  },
  (error) => {
    console.error("❌ Request interceptor error:", error);
    return Promise.reject(error);
  }
);

// ✅ Response interceptor: Handle {"message": "Unauthorized"}
api.interceptors.response.use(
  (response) => {
    // Optional: you can check response.data here as well if needed
    return response;
  },
  (error) => {
    console.error("❌ Response error:", error.response?.status, error.response?.data);

    if (
      error.response &&
      error.response.data &&
      error.response.data.message === "Unauthorized"
    ) {
      console.warn("🔒 Unauthorized access detected - clearing cookies and redirecting");
      clearAllCookies();
      window.location.href = "/signinoptions";
    }

    return Promise.reject(error); // Let the caller handle other errors
  }
);

export default api;